export default __webpack_public_path__ + "images/f0c8839b285eea3ecb56251cb50d0de5-personal_health_small.webp";